<template>
    <Modal :id="modalContatoId" size="" :open="show" :FooterDefault="false" :ClassBG="true"
        :customModalBody="'padding-top:0;'">
        <template v-slot:header>
            <h6 class="modal-title" v-if="contato_Crud.dsEmail != ''" >Editar Contato</h6>
            <h6 class="modal-title" v-else >Novo Contato</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()">
                <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
            </button>
        </template>
        <template v-slot:body>
            <div class="body">
                <div class="container-fluid">

                    <Form ref="ABC" @submit="submitForm">
                        <div class="row mt-4 mb-1">
                            <div class="col-4 d-flex">
                                <div>
                                    <label class="form-label">
                                        E-Mail do contato <small>
                                            (pode ser que o e-mail ja esteja
                                            cadastrado
                                            no sistema <i class="fa fa-search icon-search" style="color:#9F3029;"></i>
                                            )
                                        </small>
                                    </label>
                                    <Field name="dsEmail" label="E-Mail do Contato" type="email" class="form-control shadow-v2"
                                           :class="{ filled: contato_Crud.dsEmail }"
                                           style="border-bottom-right-radius: 0px;border-top-right-radius: 0px;" :rules="{ required: true, email: true }"
                                           v-model="contato_Crud.dsEmail" ref="dsEmailField"
                                           @blur="getByEmail(contato_Crud.dsEmail)" />

                                    <ErrorMessage name="dsEmail" class="form-error" v-show="showErrorMessage" />
                                </div>
                                <div style="align-self:end;">
                                    <button class="btn btnSearchContato" type="button"
                                            @click="getByEmail(contato_Crud.dsEmail)">
                                        <i class="fa fa-search icon-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-3" />
                        <div class="row mt-1 mb-1">
                            <div class="col-4">
                                <label class="form-label">Nome *</label>
                                <Field id="dsNome" name="dsNome" label="Nome" type="email" class="form-control shadow-v2"
                                       :class="{ filled: contato_Crud.nmPessoa }" rules="required" v-model="contato_Crud.nmPessoa"
                                       ref="nomeField" />
                                <ErrorMessage name="dsNome" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col-4">
                                <label class="form-label">CPF</label>
                                <Field v-maska="'###.###.###-##'" name="nrCpf" label="CPF" type="text" class="form-control shadow-v2" :class="{ filled: contato_Crud.nrCpf }" v-model="contato_Crud.nrCpf" />
                            </div>
                            <div class="col-4">
                                <label class="form-label">Gênero *</label>
                                <vue-select :options="filtroGeneros" v-model="filtroGenerosSelects" :label-by="formatNameGenero"
                                            placeholder="Digite o genero e selecione" searchable search-placeholder="Pesquise"
                                            close-on-select clear-on-select :min="1" class="form-control shadow-v2"
                                            :class="{ filled: filtroGenerosSelects.idGenero > 0 }">
                                </vue-select>
                            </div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col">
                                <label class="form-label">Departamento *</label>
                                <vue-select :options="filtroDepartamento" v-model="filtroDepartamentoSelects"
                                            :label-by="formatNameDepartamento" placeholder="Digite o nome do Departamento e selecione"
                                            searchable search-placeholder="Pesquise" close-on-select clear-on-select :min="1"
                                            class="form-control shadow-v2" :class="{ filled: contato_Crud.idDepartamento > 0 }">
                                </vue-select>
                                <Field name="idDepartamento" label="Departamento" type="hidden" rules="min_value:1"
                                       v-model="contato_Crud.idDepartamento" />
                                <ErrorMessage name="idDepartamento" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col">
                                <label class="form-label">Função *</label>
                                <vue-select :options="filtroFuncao" v-model="filtroFuncaoSelects" :label-by="formatNameFuncao"
                                            placeholder="Digite o nome da Função e selecione" searchable search-placeholder="Pesquise"
                                            close-on-select clear-on-select :min="1" class="form-control shadow-v2"
                                            :class="{ filled: contato_Crud.idFuncao > 0 }">
                                </vue-select>
                                <Field name="idFuncao" label="Função" type="hidden" rules="min_value:1"
                                       v-model="contato_Crud.idFuncao" />
                                <ErrorMessage name="idFuncao" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col">
                                <label class="form-label">Data Nascimento</label>
                                <DateInput v-model="contato_Crud.dtNascimento" class="col-12"
                                           dateFormat="DD/MM/YYYY" />
                                <ErrorMessage name="dtNascimento" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                        <hr class="mt-3" />
                        <div class="col-12">
                            <div class="row mt-1 mb-1">
                                <div class="col-4">
                                    <label class="form-label">CEP</label>
                                    <Field v-maska="'#####-###'" name="dsCep" id="dsCep" label="CEP" type="text"
                                           class="form-control shadow-v2" :class="{ filled: contato_Crud.dsCep }"
                                           v-model="contato_Crud.dsCep" @focusout="getCEP(contato_Crud.dsCep)" />
                                </div>
                            </div>
                            <div class="row mt-3 mb-3">
                                <div class="col-4">
                                    <label class="form-label">Logradouro</label>
                                    <Field name="dsEndereco" label="Logradouro" type="text" class="form-control shadow-v2"
                                           :class="{ filled: contato_Crud.dsEndereco }" v-model="contato_Crud.dsEndereco"
                                           :disabled="contato_Crud.dsEndereco != ''" />
                                </div>
                                <div class="col-1">
                                    <label class="form-label">Numero</label>
                                    <Field name="nrNumero" label="Numero" type="text" id="nrNumber"
                                           class="form-control shadow-v2" :class="{ filled: contato_Crud.nrNumero }"
                                           v-model="contato_Crud.nrNumero" ref="numeroResidenciaInput" />
                                </div>
                                <div class="col">
                                    <label class="form-label">Complemento</label>
                                    <Field name="dsComplemento" label="Complemento" type="text" class="form-control shadow-v2"
                                           :class="{ filled: contato_Crud.dsComplemento }" v-model="contato_Crud.dsComplemento" />
                                </div>
                                <div class="col">
                                    <label class="form-label">Bairro</label>
                                    <Field name="nmBairro" label="Bairro" type="text" class="form-control shadow-v2"
                                           :class="{ filled: contato_Crud.nmBairro }" v-model="contato_Crud.nmBairro"
                                           :disabled="contato_Crud.nmBairro != ''" />
                                </div>
                                <div class="col">
                                    <label class="form-label">Cidade</label>
                                    <Field name="nmCidade" label="Cidade" type="text" class="form-control shadow-v2"
                                           :class="{ filled: contato_Crud.nmCidade }" v-model="contato_Crud.nmCidade"
                                           :disabled="contato_Crud.nmCidade != ''" />
                                </div>
                                <div class="col-1">
                                    <label class="form-label">Estado</label>
                                    <Field name="nmUf" label="Estado" type="text" class="form-control shadow-v2"
                                           :class="{ filled: contato_Crud.nmUf }" v-model="contato_Crud.nmUf"
                                           :disabled="contato_Crud.nmUf != ''" />
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row mb-1 mt-1">
                                <div class="col">
                                    <label class="form-label">Telefone</label>
                                    <Field name="nrTelefone" label="Telefone" type="text" class="form-control shadow-v2"
                                           :class="{ filled: contato_Crud.nrTelefone }" v-maska="'(##) ####-####'" v-model="contato_Crud.nrTelefone" />
                                </div>
                                <div class="col">
                                    <label class="form-label">Celular</label>
                                    <Field name="nrCelular" label="Celular" type="text" class="form-control shadow-v2"
                                           :class="{ filled: contato_Crud.nrCelular }" v-maska="'(##) #####-####'"
                                           v-model="contato_Crud.nrCelular" />
                                </div>
                                <div class="col-1">
                                    <label class="form-label">Ramal</label>
                                    <Field name="nrRamal" label="Ramal" type="text" class="form-control shadow-v2"
                                           :class="{ filled: contato_Crud.nrRamal }" v-model="contato_Crud.nrRamal" />
                                </div>
                                <div class="col">
                                    <label class="form-label">Bloqueia ligação</label>
                                    <vue-select :options="filtroBloqueioLigacao" v-model="filtroBloqueioLigacaoSelects"
                                                :label-by="formatNameBloqueioLigacao" search-placeholder="Pesquise" close-on-select
                                                clear-on-select :min="1" class="form-control shadow-v2"
                                                :class="{ filled: filtroBloqueioLigacaoSelects.idBloqueioLigacao > 0 }">
                                    </vue-select>
                                    <Field name="flBloqueiaLigacao" label="Bloqueia ligação" type="hidden"
                                           v-model="contato_Crud.flBloqueiaLigacao" />
                                    <ErrorMessage name="flBloqueiaLigacao" class="form-error" v-show="showErrorMessage" />
                                </div>
                                <div class="col">
                                    <label class="form-label">Bloqueia Marketing</label>
                                    <vue-select :options="filtroBloqueioMarketing" v-model="filtroBloqueioMarketingSelects"
                                                :label-by="formatNameBloqueioMarketing" search-placeholder="Pesquise" close-on-select
                                                clear-on-select :min="1" class="form-control shadow-v2"
                                                :class="{ filled: filtroBloqueioMarketingSelects.idBloqueioMarketing > 0 }">
                                    </vue-select>
                                    <Field name="flBloqueiaMarketing" label="Bloqueia Marketing" type="hidden"
                                           v-model="contato_Crud.flBloqueiaMarketing" />
                                    <ErrorMessage name="flBloqueiaMarketing" class="form-error" v-show="showErrorMessage" />
                                </div>
                                <div class="col">
                                    <label class="form-label">Status</label>
                                    <vue-select :options="filtroStatus" v-model="filtroStatusSelects"
                                                :label-by="formatNameStatus" search-placeholder="Pesquise" close-on-select
                                                clear-on-select :min="1" class="form-control shadow-v2"
                                                :class="{ filled: filtroStatusSelects.idStatus > 0 }">
                                    </vue-select>
                                    <Field name="flAtivo" label="Status" type="hidden" v-model="contato_Crud.flAtivo" />
                                    <ErrorMessage name="flAtivo" class="form-error" v-show="showErrorMessage" />
                                </div>
                            </div>
                        </div>

                        <div class="col-12 mt-3" v-if="contato_Crud.idPessoa > 0">

                            <div class="d-flex row mt-3 mb-3">
                                <label class="label-title form-label">Telefones Complementares</label>
                                <div class="border-h4 col"></div>
                                <button type="button" class="btn-new-crud float-end col-1 ms-2" @click="openModalTelefone">
                                    <i class="fas fa-regular fa-plus"></i><span class="ms-2">Adicionar Telefone</span>
                                </button>
                            </div>

                            <DataTable :url_ajax="getUrlPessoaTelefones()" :ajax_set_result="setPessoaTelefones" @grid_refreshed="gridRefreshedPessoaTelefones"
                                       :refresh="refresh_grid_telefones" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true"
                                       :footer_fixed="false" :headers="headersTelefones" :pBtnsSlot="true" :is_NotLoading="true" :request_api="'comercial'">
                                <template v-slot:BtnSlot="item">
                                    <button type="button" class="btn-grid-editar-lista btn-editar-proposta" @click="editar_telefone(item.row.idPessoaTelefone)">
                                        <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn-grid-excluir-lista me-0" @click="excluir_telefone(item.row.idPessoaTelefone, item.row.nrTelefone)">
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                </template>
                            </DataTable>

                            <div class="d-flex flex-row-reverse mt-4">
                                <div class="d-flex flex-column">
                                    <span class='text-right'>Origem: <strong>{{ contato_Crud.dsOrigemCadastro }}</strong></span>
                                    <span class='text-right'>Incluido em: <strong>{{ contato_Crud.dtInclusao }}</strong> por: <strong>{{ contato_Crud.dsLoginInclusao }}</strong></span>
                                    <span class='text-right'>Última alteração efetuada em: <strong>{{ contato_Crud.dtAlteracao }}</strong> por: <strong>{{ contato_Crud.dsLoginAlteracao }}</strong></span>
                                </div>
                            </div>

                            <div class="row mt-2" v-if="contato_Crud.flAtivo == false">
                                <div class="col">
                                    <label class="form-label">Motivo Inativação *</label>
                                    <Field name="dsMotivoInativacao" label="Motivo" type="text" class="form-control shadow-v2" :rules="{ required: true }"
                                           :class="{ filled: contato_Crud.dsMotivoInativacao }" v-model="contato_Crud.dsMotivoInativacao" />
                                    <ErrorMessage name="dsMotivoInativacao" class="form-error" v-show="showErrorMessage" />
                                </div>
                            </div>

                            <div class="d-flex row mt-3">
                                <label class="label-title form-label">Histórico</label>
                                <div class="border-h4 col"></div>
                            </div>

                            <DataTable :url_ajax="getUrlPessoaHistorico()" :ajax_set_result="setDataTable" @grid_refreshed="gridRefreshed"
                                       :refresh="refresh_grid" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true"
                                       :footer_fixed="false" :headers="headersHistorico" :pBtnsSlot="false" :is_NotLoading="true" :request_api="'comercial'">

                            </DataTable>


                        </div>
                    </Form>
                </div>

                <ModalWarper target="TelefoneComplementar_Crud" :show="isOpenModalTelefone" @close="isOpenModalTelefone = false">
                    <TelefoneComplementar_Crud :show="isOpenModalTelefone" @fecharModalTelefone="fecharModalTelefone()" :idPessoa="idPessoaParam" :idPessoaTelefone="p_idPessoaTelefone" />
                </ModalWarper>

                <modal-warper target="ModalConfirmacao_telefone_complementar_crud_delete" :show="isOpenModalConfirmacaoDeleteTelefone" @close="(isOpenModalConfirmacaoDeleteTelefone = false)">
                    <ModalConfirmacao id="telefone_complementar_crud_delete" :title="'Excluir Telefone'" :show="isOpenModalConfirmacaoDeleteTelefone" :description="''"
                                      :red="'Deseja realmente excluir o telefone: '+ p_nrTelefone" :action="'Excluir Telefone'" @actionReturn="deleteTelefone" />
                </modal-warper>

            </div>
        </template>
        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal" @click="fecharModal()">
                    Fechar
                </button>
                <button type="submit" class="btn btn-red-v2" form="form" v-on:click="submitForm">
                    <i class="fas fa-save pe-2"></i>
                    Salvar</button>
            </div>
        </template>
    </Modal>
</template>

<script>

    import axios from 'axios';
    import VueNextSelect from 'vue-next-select';
    import 'vue-next-select/dist/index.min.css';
    import Modal from '@/components/App/Modal.vue';
    import DateInput from "@/components/App/DateInput.vue";
    import DataTable from '@/components/App/Datatable.vue';
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import TelefoneComplementar_Crud from '@/views/Modais/InstituicaoPessoas/TelefoneComplementar_Crud.vue'
    import ModalConfirmacao from '@/components/App/ModalConfirmacao.vue'

    export default {
        emits: ["getDadosOcorrenciaLigacao"],
        name: 'ContatoCrud',
        components: {
            Modal,
            DateInput,
            'vue-select': VueNextSelect,
            DataTable,
            ModalWarper,
            TelefoneComplementar_Crud,
            ModalConfirmacao,
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            idPessoa: {
                type: Number,
                default: 0
            },
            idInstituicao: {
                type: Number,
                default: 0
            },
            show: {
                type: Boolean,
                default: false
            },
            modalContatoId: {
                type: String,
                default: 'ContatoCrudNew',
                require: false
            }
        },
        data() {
            return {
                ocorrencia: {},
                isOpenModalTelefone: false,
                contato_Crud: {
                    idOcorrencia: 0,
                    nrCpf: '',
                    nmPessoa: '',
                    tpSexo: '',
                    dtNascimento: '',
                    dsEmail: '',
                    flBloqueiaLigacao: false,
                    dsMotivoBloqueiaLigacao: '',
                    flBloqueiaMarketing: false,
                    dsMotivoBloqueiaMarketing: '',
                    nrTelefone: '',
                    nrRamal: '',
                    nrCelular: '',
                    dsCep: '',
                    nmCidade: '',
                    nmUf: '',
                    nmLogradouro: '',
                    dsEndereco: '',
                    nrNumero: '',
                    nmBairro: '',
                    dsComplemento: '',
                    flAtivo: false,
                    dsOrigemCadastro: 'SISTEMA',
                    idInstituicao: 0,
                    idDepartamento: 0,
                    idFuncao: 0,
                },
                showErrorMessage: false,

                filtroDepartamento: [],
                filtroDepartamentoSelects: {},

                filtroFuncao: [],
                filtroFuncaoSelects: {},

                filtroGeneros: [{ idGenero: 1, nmGenero: 'Masculino' }, { idGenero: 2, nmGenero: 'Feminino' }],
                filtroGenerosSelects: {},

                filtroBloqueioLigacao: [{ idBloqueioLigacao: 1, nmBloqueioLigacao: 'Sim' }, { idBloqueioLigacao: 2, nmBloqueioLigacao: 'Não' }],
                filtroBloqueioLigacaoSelects: {},

                filtroBloqueioMarketing: [{ idBloqueioMarketing: 1, nmBloqueioMarketing: 'Sim' }, { idBloqueioMarketing: 2, nmBloqueioMarketing: 'Não' }],
                filtroBloqueioMarketingSelects: {},

                filtroStatus: [{ idStatus: 1, nmStatus: 'Ativo' }, { idStatus: 2, nmStatus: 'Inativo' }],
                filtroStatusSelects: { idStatus: 1, nmStatus: 'Ativo' },

                idPessoaParam: 0,
                headersTelefones: [
                    { class: 'col', name: 'nrTelefone', text: 'Telefone', order: 0 },
                    { class: 'col', name: 'nrRamal', text: 'Ramal', order: 0 },
                    { class: 'col', name: 'dsObservacao', text: 'Observações ', order: 0 },
                    { class: 'col', name: 'flAtivo', text: 'Ativo', order: 0 },
                    { class: 'col', name: 'flPrioritario', text: 'Prioritário', order: 0 },
                    { class: 'col', name: 'btns', text: '', actions: true }
                ],
                headersHistorico: [
                    { class: 'col', name: 'nmUsuario', text: 'Usuário', order: 0 },
                    { class: 'col', name: 'dtAlteracao', text: 'Data', order: 0 },
                    { class: 'col', name: 'dsAlteracao', text: 'Alteração', order: 0 },
                    { class: 'col', name: 'flValidacao', text: 'Validado', order: 0 }
                ],
                filtro: [
                    { active: true },
                ],
                refresh_grid: false,
                refresh_grid_telefones: false,
                p_idPessoaTelefone: 0,
                p_nrTelefone: '',
                isOpenModalConfirmacaoDeleteTelefone: false,
            }
        },
        methods: {

            excluir_telefone(idPessoaTelefone, nrTelefone) {
                this.p_nrTelefone = nrTelefone;
                this.p_idPessoaTelefone = idPessoaTelefone;
                this.isOpenModalConfirmacaoDeleteTelefone = true;
            },
            editar_telefone(idPessoaTelefone) {
                this.p_idPessoaTelefone = idPessoaTelefone;
                this.isOpenModalTelefone = true;
            },
            fecharModalTelefone() {
                this.refresh_grid_telefones = true;
                this.isOpenModalTelefone = false;
            },
            openModalTelefone() {
                this.p_idPessoaTelefone = 0;
                this.isOpenModalTelefone = true;
            },
            getByEmail(value) {
                let $this = this;

                if (value == '') {
                    return
                }

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/GetByEmail?dsEmail=' + value + '&idInstituicao=' + $this.idInstituicao, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.idPessoaParam = response.data.data.idPessoa;

                    $this.get();
                }).catch(function (error) {
                    var msg = 'Ocorreu um erro inesperado';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }

                    $this.$toast.show('alert', msg, true);
                    $this.zerarInformacoes($this.contato_Crud.dsEmail);
                    document.getElementById('dsNome').focus();
                });
            },
            deleteTelefone() {
                let $this = this;

                var telefone_Crud = { idPessoaTelefone: $this.p_idPessoaTelefone };

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/PessoaTelefone/Delete', telefone_Crud, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                        $this.refresh_grid_telefones = true;
                        $this.isOpenModalConfirmacaoDeleteTelefone = false;
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.$toast.show('alert', msg, true);
                    });
            },
            zerarInformacoes(dsEmail) {
                let $this = this;

                $this.idPessoaParam = 0;

                $this.filtroDepartamentoSelects = {};

                $this.filtroFuncaoSelects = {};

                $this.filtroGenerosSelects = {};

                $this.filtroBloqueioLigacaoSelects = {};

                $this.filtroBloqueioMarketingSelects = {};

                $this.filtroStatusSelects = { idStatus: 1, nmStatus: 'Ativo' };

                $this.contato_Crud = {
                    idOcorrencia: 0,
                    nrCpf: '',
                    nmPessoa: '',
                    tpSexo: '',
                    dtNascimento: '',
                    dsEmail: '',
                    flBloqueiaLigacao: false,
                    dsMotivoBloqueiaLigacao: '',
                    flBloqueiaMarketing: false,
                    dsMotivoBloqueiaMarketing: '',
                    nrTelefone: '',
                    nrRamal: '',
                    nrCelular: '',
                    dsCep: '',
                    nmCidade: '',
                    nmUf: '',
                    nmLogradouro: '',
                    dsEndereco: '',
                    nrNumero: '',
                    nmBairro: '',
                    dsComplemento: '',
                    flAtivo: false,
                    dsOrigemCadastro: 'SISTEMA',
                    idInstituicao: 0,
                    idDepartamento: 0,
                    idFuncao: 0,
                };
                if (dsEmail != null && dsEmail != '') {
                    $this.contato_Crud.dsEmail = dsEmail;
                }

                setTimeout(() => {
                    $this.filtroBloqueioLigacaoSelects = $this.filtroBloqueioLigacao[1];
                    $this.filtroBloqueioMarketingSelects = $this.filtroBloqueioMarketing[1];
                    $this.filtroStatusSelects = $this.filtroStatus.find(status => {
                        return status.idStatus == 1;
                    });
                }, 350);

                $this.showErrorMessage = false;
            },
            fecharModal() {
                this.zerarInformacoes();
            },
            formatNameDepartamento(Departamento) {
                return Departamento.nmDepartamento;
            },
            formatNameGenero(genero) {
                return genero.nmGenero;
            },
            formatNameBloqueioLigacao(result) {
                return result.nmBloqueioLigacao;
            },
            formatNameBloqueioMarketing(result) {
                return result.nmBloqueioMarketing;
            },
            formatNameStatus(result) {
                return result.nmStatus;
            },
            formatNameFuncao(Funcao) {
                return Funcao.nmFuncao;
            },
            inicializaComponente() {
                let $this = this;
                $this.filtroGeneros = [{ idGenero: 1, nmGenero: 'Masculino' }, { idGenero: 2, nmGenero: 'Feminino' }];
                $this.filtroBloqueioLigacao = [{ idBloqueioLigacao: 1, nmBloqueioLigacao: 'Sim' }, { idBloqueioLigacao: 2, nmBloqueioLigacao: 'Não' }];
                $this.filtroBloqueioMarketing = [{ idBloqueioMarketing: 1, nmBloqueioMarketing: 'Sim' }, { idBloqueioMarketing: 2, nmBloqueioMarketing: 'Não' }];
                $this.filtroStatus = [{ idStatus: 1, nmStatus: 'Ativo' }, { idStatus: 2, nmStatus: 'Inativo' }];
            },
            getDepartamento() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Departamento/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.filtroDepartamento = response.data.data.rows;
                });
            },
            getFuncao() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Funcao/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.filtroFuncao = response.data.data.rows;
                });
            },
            get() {
                let $this = this;

                if ($this.idPessoaParam == 0) {
                    $this.zerarInformacoes();

                    $this.contato_Crud.flBloqueiaLigacao = false;

                    $this.contato_Crud.flBloqueiaMarketing == false;

                    $this.contato_Crud.flAtivo == false;

                    setTimeout(() => {
                        $this.filtroBloqueioLigacaoSelects = $this.filtroBloqueioLigacao.find(BloqueioLigacao => {
                            return $this.contato_Crud.flBloqueiaLigacao == false ? BloqueioLigacao.idBloqueioLigacao == 2 : BloqueioLigacao.idBloqueioLigacao == 1;
                        });

                        $this.filtroBloqueioMarketingSelects = $this.filtroBloqueioMarketing.find(BloqueioMarketing => {
                            return $this.contato_Crud.flBloqueiaMarketing == false ? BloqueioMarketing.idBloqueioMarketing == 2 : BloqueioMarketing.idBloqueioMarketing == 1;
                        });

                        //$this.filtroStatusSelects = $this.filtroStatus.find(status => {
                        //    return $this.contato_Crud.flAtivo == false ? status.idStatus == 1 : status.idStatus == 2;
                        //});

                    }, 250);



                } else {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/Getid?idPessoa=' + $this.idPessoaParam + '&idInstituicao=' + $this.idInstituicao, {
                        headers: $this.$api.getTokenComercial(),
                        params: ''
                    }).then(response => {
                        $this.contato_Crud = response.data.data;
                        $this.contato_Crud.idInstituicao = $this.idInstituicao;
                        setTimeout(() => {
                            $this.filtroGenerosSelects = $this.filtroGeneros.find(Generos => {
                                return $this.contato_Crud.tpSexo == 'M' ? Generos.idGenero == 1 : Generos.idGenero == 2;
                            });

                            $this.filtroBloqueioLigacaoSelects = $this.filtroBloqueioLigacao.find(BloqueioLigacao => {
                                return $this.contato_Crud.flBloqueiaLigacao == true ? BloqueioLigacao.idBloqueioLigacao == 1 : BloqueioLigacao.idBloqueioLigacao == 2;
                            });

                            $this.filtroBloqueioMarketingSelects = $this.filtroBloqueioMarketing.find(BloqueioMarketing => {
                                return $this.contato_Crud.flBloqueiaMarketing == true ? BloqueioMarketing.idBloqueioMarketing == 1 : BloqueioMarketing.idBloqueioMarketing == 2;
                            });

                            $this.filtroStatusSelects = $this.filtroStatus.find(status => {
                                return $this.contato_Crud.flAtivo == true ? status.idStatus == 1 : status.idStatus == 2;
                            });

                            $this.filtroDepartamentoSelects = $this.filtroDepartamento.find(Departamento => {
                                return $this.contato_Crud.idDepartamento == Departamento.idDepartamento;
                            });

                            $this.filtroFuncaoSelects = $this.filtroFuncao.find(Funcao => {
                                return $this.contato_Crud.idFuncao == Funcao.idFuncao;
                            });

                        }, 350);
                    })
                        .catch(function (error) {
                            var msg = 'Ocorreu um erro inesperado';
                            if (error.response) {
                                if (error.response.data.erros != '') {
                                    msg = error.response.data.errors[0];
                                } else {
                                    msg = error.response.data.msg;
                                }
                            }

                            $this.$toast.show('alert', msg, true);
                        });
                }
            },
            submitForm() {
                let $this = this;


                $this.contato_Crud.idInstituicao = $this.idInstituicao;

                $this.$refs.ABC.validate()
                    .then(isValid => {
                        if (isValid.valid) {

                            if (!$this.$phoneValidator.validatePhoneCell($this.contato_Crud.nrTelefone, $this.contato_Crud.nrCelular)) {
                                $this.$toast.show('alert', 'Telefone ou celular é obrigatório e deve estar completo!', true);
                                return;
                            }

                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/Post', $this.contato_Crud, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    var myModalEl = document.getElementById($this.modalContatoId);
                                    var ModalNewContato = window.bootstrap.Modal.getInstance(myModalEl);

                                    $this.zerarInformacoes();

                                    $this.$emit('getDadosOcorrenciaLigacao');
                                    $this.$emit('reloadGrid');

                                    ModalNewContato.hide();
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatórios.';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
            getCEP(value) {
                let $this = this;
                if (value && value.trim() !== "") {
                    axios.get('https://viacep.com.br/ws/' + value + '/json/', {
                        headers: $this.$api.getTokenComercial(),
                        params: ''
                    }).then(response => {
                        $this.contato_Crud = {
                            ...$this.contato_Crud,
                            dsCep: response.data.cep,
                            nmCidade: response.data.localidade,
                            nmUf: response.data.uf,
                            dsEndereco: response.data.logradouro,
                            nmBairro: response.data.bairro
                        };
                    });
                }
            },
            getUrlPessoaTelefones() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/PessoaTelefone/GetGrid?idPessoa=' + $this.idPessoaParam;
            },
            setPessoaTelefones(result) {
                return result;
            },
            gridRefreshedPessoaTelefones(data_ajax) {
                let $this = this;
                $this.refresh_grid_telefones = false;
            },
            setDataTable(result) {
                result.forEach((value, index) => {
                    value.dsAlteracao = 'Campo: ' + value.nmCampoAlterado + ' de ' + value.vlrCampoAnterior + ' para: ' + value.vlrCampoAtual; + '.'

                })
                return result;
            },
            gridRefreshed(data_ajax) {
                let $this = this;
                $this.refresh_grid = false;
            },
            getUrlPessoaHistorico() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/PessoaInstituicaoHistorico/Get?idPessoa=' + $this.idPessoaParam;
            },

        },
        mounted() {
            let $this = this;

            $this.idPessoaParam = $this.idPessoa;
            $this.get();
            $this.inicializaComponente();
            $this.getDepartamento();
            $this.getFuncao();

            this.$nextTick(() => {
                document.addEventListener('keydown', function (event) {
                    if (event.key === 'Tab') {
                        if (document.activeElement.id === 'dsCep') {
                            event.preventDefault();
                            document.getElementById('nrNumber').focus();
                        } else {
                            document.activeElement.blur();
                        }
                    }
                });
            });
        },
        updated() {
        },
        watch: {
            show(new_value, old_value) {
                if (new_value) {

                    if (this.idPessoa > 0) {
                        this.idPessoaParam = this.idPessoa;
                        this.get();
                    }

                    this.get();
                    this.inicializaComponente();
                    this.getDepartamento();
                    this.getFuncao();
                }
            },
            filtroDepartamentoSelects(newValue, oldValue) {
                if (newValue) {
                    this.contato_Crud.idDepartamento = newValue.idDepartamento;
                }
            },
            filtroFuncaoSelects(newValue, oldValue) {
                if (newValue) {
                    this.contato_Crud.idFuncao = newValue.idFuncao;
                }
            },
            filtroGenerosSelects(newValue, oldValue) {
                if (newValue) {
                    this.contato_Crud.tpSexo = newValue.nmGenero == 'Masculino' ? 'M' : 'F';
                }
            },
            filtroBloqueioLigacaoSelects(newValue, oldValue) {
                if (newValue) {
                    this.contato_Crud.flBloqueiaLigacao = newValue.nmBloqueioLigacao == 'Sim' ? true : false;
                }
            },
            filtroBloqueioMarketingSelects(newValue, oldValue) {
                if (newValue) {
                    this.contato_Crud.flBloqueiaMarketing = newValue.nmBloqueioMarketing == 'Sim' ? true : false;
                }
            },
            filtroStatusSelects(newValue, oldValue) {
                if (newValue) {
                    this.contato_Crud.flAtivo = newValue.nmStatus == 'Ativo' ? true : false;
                }
            },
            idInstituicao(newValue, oldValue) {
                this.contato_Crud.idInstituicao = newValue;
            },
            idPessoa(newValue, oldValue) {
                this.idPessoaParam = newValue;
            },
            idOcorrencia(newValue, oldValue) {
                this.contato_Crud.idOcorrencia = newValue;
            }
        }
    }

</script>

<style scoped lang="scss">

    .body {
        min-height: calc(100vh - 7rem);
        max-height: calc(100vh - 7rem);
        overflow-y: auto; /* Permite rolagem vertical */
        overflow-x: hidden; /* Oculta a rolagem horizontal */
        background: #f9f9f9;
    }

    .btnSearchContato {
        padding: 6px;
        padding-left: 10px;
        margin-top: 1px;
        background-color: #9F3029;
        padding-right: 10px;
        border-bottom-left-radius: 0px;
        border-top-left-radius: 0px;

        i {
            color: white
        }

        &:hover {
            background-color: #9F3029 !important;

            i {
                color: white !important;
            }
        }
    }

    .label-title {
        color: black;
        width: max-content;
        margin-bottom: 0px;
        margin-top: 6px;
    }

    .border-h4 {
        height: 5px;
        border-bottom: 1px solid #BBBBBB;
        margin-top: 13px;
    }

    .btn-new-crud {
        color: #FFFFFF;
        background: #9F3029;
        padding: 7px 0px !important;
        border-radius: 5px;
        font-weight: 500;
        font-size: 12px;
        border: none;
        margin-right: 0.9rem;
    }

    .btn-new-crud:hover {
        color: #FFFFFF;
        background: #B7413C;
        padding: 7px 0px !important;
        border-radius: 5px;
        font-weight: 500;
        font-size: 12px;
        border: none;
        margin-right: 0.9rem;
    }

    .text-div {
        color: #808080;
    }


    .btn-grid-excluir-lista {
        width: unset;
        max-height: 35px;
    }

    .btn-editar-proposta {
        background-color: #297C9F;
    }
</style>